import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
} from '@angular/core';
import { TelXLPanelComponent } from '@dxp/elements';
import { NgbProgressbar } from '@ng-bootstrap/ng-bootstrap';
import { IUploader } from '../upload-panel.component';

@Component({
    selector: 'telxl-shared-uploading',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, TelXLPanelComponent, NgbProgressbar],
    templateUrl: './uploading-panel.component.html',
    styleUrl: './uploading-panel.component.scss',
})
export class TelXLUploadingPanelComponent {
    upload = input.required<IUploader>();

    timeRemaining = computed<string>(() => {
        const remaining = this.upload().remaining;
        const progress = this.upload().progress;

        if (remaining === 0 && progress < 25) {
            return 'Calculating remaining time';
        } else if (remaining > 1) {
            return `${remaining} seconds remaining`;
        } else {
            return '<1 second remaining';
        }
    });
}
